import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core';
import DefaultDivider from '@material-ui/core/Divider';

import Typography from '../Typography';

import { DividerProps } from './Divider.types';

const useStyle = makeStyles({
  root: {
    height: '32px',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    top: '50%',
    width: '32px'
  }
});

const Divider: React.FC<DividerProps> = ({ showOr, ...other }) => {
  const classes = useStyle();

  return showOr ? (
    <div className="relative width-100">
      <DefaultDivider {...other} />
      <Typography
        variant="SemiBold100"
        className={clsx(
          'absolute br16 secondary-background dark flex flex-center flex-justify-center',
          classes.root
        )}
      >
        OR
      </Typography>
    </div>
  ) : (
    <DefaultDivider {...other} />
  );
};

export default Divider;
